import { action, computed } from 'mobx';

import { ITranslationsCollection, ViewController } from '@estee/elc-service';
import { emit, events } from '@estee/elc-service-bus';

import { LoyaltyRepository } from '~repositories/LoyaltyRepository';
import { LoadLoyaltyInfoUseCase } from '~use-cases/LoadLoyaltyInfoUseCase';

import { IRewardsLink } from './LoyaltyTierCommon';

class LoyaltyTierController extends ViewController {
    private loyaltyRepository: LoyaltyRepository;

    constructor(loyaltyRepository: LoyaltyRepository) {
        super();
        this.loyaltyRepository = loyaltyRepository;
    }

    public onRewardsLinkClick = (loyaltyLinkData: IRewardsLink) => {
        const { label } = loyaltyLinkData;
        emit(events.ACCOUNT_SIDEBAR_LOYALTY_LINK_CLICKED, { label });
    };

    @action
    public loaded = async () => {
        this.isLoading = true;
        await new LoadLoyaltyInfoUseCase().execute();
        this.isLoading = false;
    };

    @action
    public getLoyaltyLabel = (translations: ITranslationsCollection) => {
        const level = this.loyaltyRepository?.loyaltyInfo?.levelValue;
        const loyaltyTierLabel: string = translations[`loyaltyTier${level}`];

        return loyaltyTierLabel;
    };

    @computed
    public get data() {
        return {
            loyaltyInfo: this.loyaltyRepository?.loyaltyInfo
        };
    }
}

export default LoyaltyTierController;
